import { createIconComponent } from '../../factory/create-icon-component';
export const LoadingIcon = createIconComponent(
  'LoadingIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.75 6.75008L19.1142 4.38593M4.38623 19.1139L6.75019 16.7499"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75038 6.75008L4.38623 4.38593M19.1142 19.1139L16.7502 16.7499"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.75 11.75L5.09315 11.75M21.75 11.75L18.4066 11.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.75 21.7501L11.75 18.4069M11.75 1.75006L11.75 5.09348"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
